import { FormattedMessage } from 'react-intl';
import GeneralFormValidationsAlert from 'components/forms/GeneralFormValidationsAlert';
import { useWizardValidationResults } from './hooks/useWizardValidationResults';

export function WizardValidationMessages() {
    const { globalErrors, globalWarnings, clearGlobalErrors, clearGlobalWarnings } = useWizardValidationResults();

    const hasErrors = globalErrors.length > 0;
    const hasWarnings = globalWarnings.length > 0;

    return (
        <div>
            {hasErrors && (
                <GeneralFormValidationsAlert
                    title={<FormattedMessage id="common_error" />}
                    isOpen={hasErrors}
                    onClose={clearGlobalErrors}
                    messages={globalErrors}
                />
            )}

            {hasWarnings && (
                <GeneralFormValidationsAlert
                    status="warning"
                    title={<FormattedMessage id="common_warning" />}
                    isOpen={hasWarnings}
                    onClose={clearGlobalWarnings}
                    messages={globalWarnings}
                />
            )}
        </div>
    );
}
